export const ROOT_PATH = '/';

export const LOGIN_PATH = '/login/:server?/';
export const REGISTER_PATH = '/register/:server?/';
export const RESET_PASSWORD_PATH = '/reset-password/:server?/';

export const _CREATE_PATH = 'create/';
export const _JOIN_PATH = 'join/';
export const _LOBBY_PATH = 'lobby/';
export const _SEARCH_PATH = 'search/';
export const _ROOM_PATH = ':roomIdOrAlias/:eventId?/';

export const HOME_PATH = '/home/';
export const HOME_CREATE_PATH = `/home/${_CREATE_PATH}`;
export const HOME_JOIN_PATH = `/home/${_JOIN_PATH}`;
export const HOME_SEARCH_PATH = `/home/${_SEARCH_PATH}`;
export const HOME_ROOM_PATH = `/home/${_ROOM_PATH}`;

export const DIRECT_PATH = '/direct/';
export const DIRECT_CREATE_PATH = `/direct/${_CREATE_PATH}`;
export const DIRECT_ROOM_PATH = `/direct/${_ROOM_PATH}`;

export const SPACE_PATH = '/:spaceIdOrAlias/';
export const SPACE_LOBBY_PATH = `/:spaceIdOrAlias/${_LOBBY_PATH}`;
export const SPACE_SEARCH_PATH = `/:spaceIdOrAlias/${_SEARCH_PATH}`;
export const SPACE_ROOM_PATH = `/:spaceIdOrAlias/${_ROOM_PATH}`;

export const _FEATURED_PATH = 'featured/';
export const _SERVER_PATH = ':server/';
export const EXPLORE_PATH = '/explore/';
export const EXPLORE_FEATURED_PATH = `/explore/${_FEATURED_PATH}`;
export const EXPLORE_SERVER_PATH = `/explore/${_SERVER_PATH}`;

export const CREATE_PATH = '/create/';

export const _NOTIFICATIONS_PATH = 'notifications/';
export const _INVITES_PATH = 'invites/';
export const INBOX_PATH = '/inbox/';
export const INBOX_NOTIFICATIONS_PATH = `/inbox/${_NOTIFICATIONS_PATH}`;
export const INBOX_INVITES_PATH = `/inbox/${_INVITES_PATH}`;

/** SvelteKit route ids for exact-match checks (Cinny's `useMatch(end: true)`). */
export const RouteId = {
	HOME: '/(client)/home',
	HOME_CREATE: '/(client)/home/create',
	HOME_JOIN: '/(client)/home/join',
	HOME_SEARCH: '/(client)/home/search',
	HOME_ROOM: '/(client)/home/[roomIdOrAlias]/[[eventId]]',
	DIRECT: '/(client)/direct',
	DIRECT_CREATE: '/(client)/direct/create',
	DIRECT_ROOM: '/(client)/direct/[roomIdOrAlias]/[[eventId]]',
	SPACE: '/(client)/[spaceIdOrAlias]',
	SPACE_LOBBY: '/(client)/[spaceIdOrAlias]/lobby',
	SPACE_SEARCH: '/(client)/[spaceIdOrAlias]/search',
	SPACE_ROOM: '/(client)/[spaceIdOrAlias]/[roomIdOrAlias]/[[eventId]]',
	EXPLORE: '/(client)/explore',
	EXPLORE_FEATURED: '/(client)/explore/featured',
	INBOX: '/(client)/inbox',
	INBOX_NOTIFICATIONS: '/(client)/inbox/notifications',
	INBOX_INVITES: '/(client)/inbox/invites',
	CREATE: '/(client)/create'
} as const;

export const NAV_ROOT_ROUTE_IDS: readonly string[] = [
	RouteId.HOME,
	RouteId.DIRECT,
	RouteId.SPACE,
	RouteId.EXPLORE,
	RouteId.INBOX,
	RouteId.CREATE
];
